import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericFilter } from '../models/GenericFilter';
import { PermissionDto, PermissionForCreationDto, PermissionForUpdateDto, ProjectPermissionDto, TenantPermissionDto } from '../models/PermissionForCreationDto';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';
import { TenantService } from './tenant.service';

@Injectable({providedIn: 'root'})
export class PermissionsService  extends BaseService {
 

  constructor(private httpClient: HttpClient, private oauthService: OAuthServiceService, private tenantService: TenantService) {
    super();
  }

  loadTenantPermissions(tenant: string, genericFilter: GenericFilter) : Observable<TenantPermissionDto[]> {
    var self = this;
    return new Observable<TenantPermissionDto[]>((subscriber)=>{
      self.tenantService.getToken(tenant).subscribe({
        next: (token) => {
          self.tenantService.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.get<TenantPermissionDto[]>(`${this.tenantpermissions}/GetTenantPermissions/${tenant}`, {headers: headers}).subscribe ({
            next:(roles) => {
              subscriber.next(roles);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
     
    // const headers = new HttpHeaders()
    //   .set('Authorization', `Bearer ${this.oauthService.token}`)
    //   .set('dbname', tenantdb);
    // return this.httpClient.get<TenantPermissionDto[]>(`${this.tenantpermissions}/GetTenantPermissions/${tenantdb}`, {headers: headers});
  }

  loadProjectPermissions(tenant: string, genericFilter: GenericFilter) : Observable<ProjectPermissionDto[]> {
    var self = this;
    return new Observable<ProjectPermissionDto[]>((subscriber)=>{
      self.tenantService.getToken(tenant).subscribe({
        next: (token) => {
          self.tenantService.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectPermissionDto[]>(`${this.tenantpermissions}/GetFilteredProjectPermissions/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(roles) => {
              subscriber.next(roles);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
     
    // const headers = new HttpHeaders()
    //   .set('Authorization', `Bearer ${this.oauthService.token}`)
    //   .set('dbname', tenantdb);
    // return this.httpClient.post<ProjectPermissionDto[]>(`${this.tenantpermissions}/GetFilteredProjectPermissions/${tenantdb}`, genericFilter, {headers: headers});
  }

  
  // folgende Services werden niemals gerufen (sonst bräuchten sie einen Header mit Authorization Teil, in dem der UserToken oder der Application Token steckt)
  // können also ausgebaut werden
  loadPermissions(searchText: string, currentPage: number, pageSize: number) : Observable<PermissionForCreationDto[]> {
    return this.httpClient.get<PermissionForCreationDto[]>(`${this.permissions}/GetPermissions?searchText=${searchText}&page=${currentPage}&pageSize=${pageSize}`);
  }

  getPermissions(genericFilter: GenericFilter) : Observable<PermissionForCreationDto[]> {
    return this.httpClient.post<PermissionForCreationDto[]>(`${this.permissions}/GetFilteredPermissions`, genericFilter);
  }

  getPermission(id: string) : Observable<PermissionDto> {
    return this.httpClient.get<PermissionDto>(`${this.permissions}/${id}`);
  }

  createPermission(permissionForCreationDto: PermissionDto) : Observable<PermissionDto> {
    return this.httpClient.post<PermissionDto>(`${this.permissions}`, permissionForCreationDto);
  }

  updatePermission(permissionForCreationDto: PermissionForUpdateDto): Observable<PermissionForUpdateDto> {
    return this.httpClient.put<PermissionForUpdateDto>(`${this.permissions}`, permissionForCreationDto);
  }

  deletePermission(id: string) : Observable<any> {
    return this.httpClient.delete<any>(`${this.permissions}/${id}`);
  }
}
